import { Grid, TextField } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import useInputObject from "../../hooks/useInputObject";
import CommonAutocomplete from "../../components/CommonAutocomplete";
import SALES_RECORD_TYPE from "../../utils/variable";
import { filterAutoComplete, increaseCountRerender } from "../../utils/utils";

const HeaderTextField = (props) => {
  return (
    <TextField
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        paddingInline: 0,
      }}
      {...props}
    >
      {props.children}
    </TextField>
  );
};

const MAP_DETAIL_PROP = {
  0: "rankId",
  1: "productClassId",
  2: "packingId",
  3: "weight",
  4: "quantity",
  5: "purchacePrice",
};

const SalesDetailItem = (props) => {
  const {
    index,
    apiSalesDetails,
    ranks,
    productClasses,
    packings,
    focusNavigation,
    salesRecordType,
    insertedInvoice,
    renderState,
    setting,
    salesDetail,
    updateIndexProp,
    changeHistoryItem
  } = props;
  const [rank, setRank] = useState({});
  const [productClass, setProductClass] = useState({});
  const [packing, setPacking] = useState({});
  // increaseCountRerender();
  // console.log("Rerender Detail : ", index);
  useEffect(() => {
    setRank(ranks.find((x) => x.rankId === apiSalesDetails[index]?.rankId));
    setProductClass(
      productClasses.find(
        (x) => x.productClassId === apiSalesDetails[index]?.productClassId
      )
    );
    setPacking(
      packings.find((x) => x.packingId === apiSalesDetails[index]?.packingId)
    );
    renderState.update(`detail-${index}`, true);
  }, [apiSalesDetails]);

  useEffect(() => {
    updateIndexProp(index, "rankId", rank?.rankId || "");
  }, [rank]);
  useEffect(() => {
    updateIndexProp(
      index,
      "productClassId",
      productClass?.productClassId || ""
    );
  }, [productClass]);
  useEffect(() => {
    updateIndexProp(index, "packingId", packing?.packingId || "");
  }, [packing]);

  function handleFocus(e) {
    e.target.select();
  }

  const handleKeyDown = useCallback(
    (event) => {
      const keyCode = event.keyCode;
      //過去に登録した販売原票データをコピーする
      //Pressed ESC
      if (keyCode === 27) {
        event.preventDefault();
        const previousDetails = insertedInvoice.Value.listSalesDetailInfo;
        // console.log(previousDetails);
        const targetId = event.target.id;
        const targetRow = targetId.split("-")[1];
        const targetCol = targetId.split("-")[2];

        const prevValue =
          previousDetails[targetRow][MAP_DETAIL_PROP[targetCol]];
        if (!prevValue) return;
        event.target.value = prevValue;
        if (MAP_DETAIL_PROP[targetCol] == "rankId") {
          const selectedRank = ranks.find((x) => x.rankId === prevValue);
          setRank(selectedRank);
          changeHistoryItem(`detail-${index}-rankId`, prevValue, selectedRank?.rankName);
        } else if (MAP_DETAIL_PROP[targetCol] == "productClassId") {
          const selectedProductClass = productClasses.find((x) => x.productClassId === prevValue);
          setProductClass(selectedProductClass);
          changeHistoryItem(`detail-${index}-productClassId`, prevValue, selectedProductClass?.productClassName);
        } else if (MAP_DETAIL_PROP[targetCol] == "packingId") {
          const selectedPacking = packings.find((x) => x.packingId === prevValue);
          setPacking(selectedPacking);
          changeHistoryItem(`detail-${index}-packingId`, prevValue, selectedPacking?.packingName);
        } else {
          updateIndexProp(index, MAP_DETAIL_PROP[targetCol], prevValue);
          changeHistoryItem(`detail-${index}-${MAP_DETAIL_PROP[targetCol]}`, prevValue);
        }
        focusNavigation(event.target, false);
      }
    },
    [insertedInvoice.Value.listSalesDetailInfo, ranks, productClasses, packings, changeHistoryItem]
  );
  return (
    <Grid container my={1} onFocus={handleFocus} onKeyDown={handleKeyDown}>
      <Grid
        item
        xs={12}
        justifyContent="start"
        display={"flex"}
        id={`salesDetail-${index}`}
      >
        <Grid item xs={1}>
          <HeaderTextField
            sx={{
              width: "90%",
            }}
            value={salesDetail.salesDetailNo}
            disabled
          ></HeaderTextField>
        </Grid>
        {/* 等級 */}
        <Grid item xs={2}>
          <CommonAutocomplete
            value={rank || null}
            onSelect={(e, newValue) => {
              setRank(newValue);
              focusNavigation(document.activeElement, false);
              changeHistoryItem(`detail-${index}-rankId`, newValue?.rankId || null, newValue?.rankName || null);
            }}
            id={`salesDetail-${index}${
              salesRecordType === SALES_RECORD_TYPE.LOCAL ? "" : "-0"
            }`}
            data={ranks}
            filterOptions={(options, { inputValue }) => {
              inputValue = inputValue.trim();
              return options.filter((x) => {
                return x.rankId.toString().startsWith(inputValue);
              });
            }}
            optionLabel={(option) =>
              option ? option.rankId + " - " + option.rankName : ""
            }
            width="90%"
            disabled={
              salesRecordType === SALES_RECORD_TYPE.STOCK ||
              salesRecordType === SALES_RECORD_TYPE.LOCAL ||
              setting.Value.invoiceIsDisabled
            }
          />
        </Grid>
        {/* 階級 */}
        <Grid item xs={2}>
          <CommonAutocomplete
            // label="階級"
            value={productClass || null}
            onSelect={(e, newValue) => {
              setProductClass(newValue);
              focusNavigation(document.activeElement, false);
              changeHistoryItem(`detail-${index}-productClassId`, newValue?.productClassId, newValue?.productClassName);
            }}
            // id={`salesDetail-${index}-1`}
            id={`salesDetail-${index}${
              salesRecordType === SALES_RECORD_TYPE.LOCAL ? "" : "-1"
            }`}
            data={productClasses}
            filterOptions={(options, { inputValue }) => {
              inputValue = inputValue.trim();
              return options.filter((x) => {
                return x.productClassId.toString().startsWith(inputValue);
              });
            }}
            optionLabel={(option) =>
              option
                ? option.productClassId + " - " + option.productClassName
                : ""
            }
            width="90%"
            disabled={
              salesRecordType === SALES_RECORD_TYPE.STOCK ||
              salesRecordType === SALES_RECORD_TYPE.LOCAL ||
              setting.Value.invoiceIsDisabled
            }
          />
        </Grid>
        {/* 荷姿 */}
        <Grid item xs={2}>
          <CommonAutocomplete
            // label="荷姿"
            value={packing || null}
            onSelect={(e, newValue) => {
              setPacking(newValue);
              focusNavigation(document.activeElement, false);
              changeHistoryItem(`detail-${index}-packingId`, newValue?.packingId, newValue?.packingName);
            }}
            // id={`salesDetail-${index}-2`}
            id={`salesDetail-${index}${
              salesRecordType === SALES_RECORD_TYPE.LOCAL ? "" : "-2"
            }`}
            data={packings}
            filterOptions={(options, { inputValue }) => {
              inputValue = inputValue.trim();
              return options.filter((x) => {
                return x.packingId.toString().startsWith(inputValue);
              });
            }}
            optionLabel={(option) =>
              option ? option.packingId + " - " + option.packingName : ""
            }
            width="90%"
            disabled={
              salesRecordType === SALES_RECORD_TYPE.STOCK ||
              salesRecordType === SALES_RECORD_TYPE.LOCAL ||
              setting.Value.invoiceIsDisabled
            }
          />
        </Grid>
        {/* 量目 */}
        <Grid item xs={2}>
          <HeaderTextField
            sx={{ width: "90%" }}
            value={salesDetail.weight || ""}
            onChange={(e) => {
              updateIndexProp(index, "weight", e.target.value);
              changeHistoryItem(`detail-${index}-weight`, e.target.value);
            }}
            // id={`salesDetail-${index}-3`}
            id={`salesDetail-${index}${
              salesRecordType === SALES_RECORD_TYPE.LOCAL ? "-0" : "-3"
            }`}
            type="number"
            disabled={
              salesRecordType === SALES_RECORD_TYPE.STOCK ||
              setting.Value.invoiceIsDisabled
            }
          ></HeaderTextField>
        </Grid>
        {/* 数量 */}
        <Grid item xs={1.5}>
          <HeaderTextField
            sx={{ width: "90%" }}
            value={salesDetail.quantity || ""}
            onChange={(e) => {
              updateIndexProp(index, "quantity", e.target.value);
              changeHistoryItem(`detail-${index}-quantity`, e.target.value);
            }}
            type="number"
            // id={`salesDetail-${index}-4`}
            id={`salesDetail-${index}${
              salesRecordType === SALES_RECORD_TYPE.LOCAL ? "-1" : "-4"
            }`}
            disabled={
              salesRecordType === SALES_RECORD_TYPE.STOCK ||
              setting.Value.invoiceIsDisabled
            }
          ></HeaderTextField>
        </Grid>

        {/* 指値 */}
        {(salesRecordType === SALES_RECORD_TYPE.TRAVEL ||
          salesRecordType === SALES_RECORD_TYPE.STOCK) && (
          <Grid item xs={1.5}>
            <HeaderTextField
              sx={{ width: "100%" }}
              value={salesDetail.purchacePrice || ""}
              onChange={(e) => {
                updateIndexProp(index, "purchacePrice", e.target.value);
                changeHistoryItem(`detail-${index}-purchacePrice`, e.target.value);
              }}
              // id={`salesDetail-${index}-5`}
              id={`salesDetail-${index}${
                salesRecordType === SALES_RECORD_TYPE.LOCAL ? "" : "-5"
              }`}
              type="number"
              disabled={
                salesRecordType === SALES_RECORD_TYPE.STOCK ||
                setting.Value.invoiceIsDisabled
              }
            ></HeaderTextField>
          </Grid>
        )}
        {/* 内容明細 */}
        {salesRecordType === SALES_RECORD_TYPE.LOCAL && (
          <Grid item xs={1.5}>
            <HeaderTextField
              sx={{ width: "100%" }}
              value={salesDetail.remarks || ""}
              onChange={(e) =>
                updateIndexProp(index, "remarks", e.target.value)
              }
              // id={`salesDetail-${index}-5`}
              // id={`salesDetail-${index}${
              //   salesRecordType === SALES_RECORD_TYPE.LOCAL ? "" : "-5"
              // }`}
              disabled={
                salesRecordType === SALES_RECORD_TYPE.STOCK ||
                salesRecordType === SALES_RECORD_TYPE.LOCAL ||
                setting.Value.invoiceIsDisabled
              }
            ></HeaderTextField>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

function areEqual(prevProps, nextProps) {
  if (
    prevProps.salesDetail === nextProps.salesDetail
    // &&  prevProps.apiSalesDetails === nextProps.apiSalesDetails
    // &&  prevProps.ranks === nextProps.ranks
    // &&  prevProps.productClasses === nextProps.productClasses
    // &&  prevProps.packings === nextProps.packings
    // &&  prevProps.salesRecordType === nextProps.salesRecordType
    // &&  prevProps.insertedInvoice === nextProps.insertedInvoice
    // &&  prevProps.renderState === nextProps.renderState
    // &&  prevProps.setting === nextProps.setting
    // &&  prevProps.productClasses === nextProps.productClasses
    // &&  prevProps.packings === nextProps.packings
    // &&  prevProps.updateIndexProp === nextProps.updateIndexProp
  ) {
    return true; // Props are equal, do not re-render
  } else {
    // console.log(prevProps.salesDetail, nextProps.salesDetail);
  }
  return false;
}

export default memo(SalesDetailItem, areEqual);
